import React from "react";
import { Box, Typography } from "@mui/material";
import { CustomInput, getIcon } from "@dishopsaas/design-system";
import ModalBody from "../../../components/ModalBody/ModalBody.view";
import getStyles from './OrdersFilter.styles';
import { Popover } from "@mui/material";
import {
    FILTER_STATUS_OPTIONS,
    FILTER_DATE_OPTIONS,
} from "../../../constants/ordersFilter";
import { ICONS } from "../../../constants";

type Filters = {
    status: string[];
    date: string;
};

type OrdersFilterProps = {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    filters: Filters;
    setFilters: (filters: Filters) => void;
};



const InputItem = ({ checked, label, onChange, type, styles }: any) => (
    <Box sx={{ ...styles.title, height: '32px' }} onClick={onChange}>
        <CustomInput type={type} checked={checked} onChange={onChange} isCustomInput />
        <Typography variant='body2'>{label}</Typography>
    </Box>
);

const Section = ({ icon, title, children }: any) => {
    const styles = getStyles()
    return (
        <Box sx={styles.section}>
            <Box sx={styles.title}>
                {getIcon(icon, { size: 16 })}
                <Typography variant="body1">{title}</Typography>
            </Box>
            {children}
        </Box>
    )
};

const OrdersFilter: React.FC<OrdersFilterProps> = ({
    anchorEl,
    onClose,
    filters,
    setFilters,
}) => {
    const open = Boolean(anchorEl);
    const styles = getStyles()



    const handleDateChange = (value: string) => {
        const newFilters = { ...filters, date: value };
        setFilters(newFilters);
    };


    const handleStatusChange = (value: string) => {
        const exists = filters.status.includes(value);

        const updated = exists
            ? filters.status.filter((s) => s !== value)
            : [...filters.status, value];

        setFilters({ ...filters, status: updated });
    };



    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            PaperProps={{
                sx: {
                    ...styles.popover,
                    mt: 1.5
                }
            }}
        >
            <ModalBody
                title="Filtres"
                onClose={onClose}
                sxBody={{ pt: 0, width: { md: 380 } }}
            >
                <Box sx={styles.container}>
                    <Section
                        title="Périodes"
                        icon={ICONS.Calendar}
                    >
                        <Box>
                            {FILTER_DATE_OPTIONS.map((opt) => (
                                <InputItem
                                    key={opt.value}
                                    label={opt.label}
                                    checked={filters?.date === opt.value}
                                    onChange={() => handleDateChange(opt.value)}
                                    styles={styles}
                                    type='radio'
                                />
                            ))}
                        </Box>
                    </Section>


                    <Section
                        title="Statut de la commande"
                        icon={ICONS.PackageCheck}
                    >
                        <Box >
                            {FILTER_STATUS_OPTIONS.map((opt) => (
                                <InputItem
                                    key={opt.value}
                                    label={opt.label}
                                    checked={filters.status.includes(opt.value)}
                                    onChange={() => handleStatusChange(opt.value)}
                                    type='checkbox'
                                    styles={styles}
                                />
                            ))}
                        </Box>
                    </Section>
                </Box>
            </ModalBody>
        </Popover>
    );
};

export default OrdersFilter;